import { Component, signal, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from './auth/auth.service';
import { AppLoaderComponent } from './shared/components/app-loader/app-loader.component';
import { GlobalConfirmDialogComponent } from './shared/components/global-confirm-dialog/global-confirm-dialog.component';
import { GlobalPromptDialogComponent } from './shared/components/global-prompt-dialog/global-prompt-dialog.component';
import { ProgressIndicatorComponent } from './features/lots/components/statement-generation-progress/statement-generation-progress.component';
import { PwaUpdateNotificationComponent } from './shared/components/pwa-update-notification/pwa-update-notification';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, AppLoaderComponent, GlobalConfirmDialogComponent, GlobalPromptDialogComponent, ProgressIndicatorComponent, PwaUpdateNotificationComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('agrixe-auctions');
  private authService = inject(AuthService);
  isInitializing = signal(true);
  async ngOnInit() {
    const startTime = Date.now();
    try {
      // Initialize authentication on app startup and wait for it to complete
      await this.authService.initializeAuth();
    } catch (error) {
    }
    // Ensure loader shows for at least 300ms for smooth UX
    const elapsedTime = Date.now() - startTime;
    const minimumLoadTime = 1200;
    if (elapsedTime < minimumLoadTime) {
      await new Promise(resolve => setTimeout(resolve, minimumLoadTime - elapsedTime));
    }
    // Stop showing loader (use setTimeout to avoid ExpressionChangedAfterItHasBeenCheckedError)
    setTimeout(() => this.isInitializing.set(false), 0);
  }
}
